export enum Type {
  AJAX_FETCH_CONFIG                    = 'AJAX_FETCH_CONFIG',
  AJAX_FETCH_CONFIG_FAIL               = 'AJAX_FETCH_CONFIG_FAIL',
  AJAX_FETCH_CONFIG_SUCCESS            = 'AJAX_FETCH_CONFIG_SUCCESS',
  AJAX_GET_LOAN_OFFICER_DETAIL         = 'AJAX_GET_LOAN_OFFICER_DETAIL',
  AJAX_GET_LOAN_OFFICER_DETAIL_FAIL    = 'AJAX_GET_LOAN_OFFICER_DETAIL_FAIL',
  AJAX_GET_LOAN_OFFICER_DETAIL_SUCCESS = 'AJAX_GET_LOAN_OFFICER_DETAIL_SUCCESS',
}
